import { apiRequest } from './httpClient';

// Daily Ranges endpoints return the shared API envelope: { success, data, meta, error }.
// List responses are server-paginated; use meta.total/meta.has_more for pagination UI.

export async function getDailyRangesConfig(options = {}) {
    const body = await apiRequest('/daily-ranges/config', options);
    return body.data || {};
}

export async function updateDailyRangesConfig(telegramEnabled) {
    const body = await apiRequest('/daily-ranges/config', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ telegram_enabled: telegramEnabled })
    });
    return body.data || {};
}

export async function getDailyRangesSummary(days = 3, options = {}) {
    const body = await apiRequest(`/daily-ranges/summary?days=${days}`, options);
    return body.data || {};
}

export async function getDailyRangesList({ days = 3, constant = false, q = '', limit = 500, offset = 0 } = {}, options = {}) {
    const params = new URLSearchParams({
        days: String(days),
        constant: String(constant),
        limit: String(limit),
        offset: String(offset)
    });
    if (q && q.trim()) params.set('q', q.trim());
    const body = await apiRequest(`/daily-ranges/list?${params.toString()}`, options);
    return {
        rows: body.data || [],
        meta: body.meta || {}
    };
}

export async function getDailyRangeValues({ days = 3, constant = false, q = '' } = {}, options = {}) {
    const params = new URLSearchParams({
        days: String(days),
        constant: String(constant)
    });
    if (q && q.trim()) params.set('q', q.trim());
    const body = await apiRequest(`/daily-ranges/ranges?${params.toString()}`, options);
    return {
        ranges: body.data || [],
        meta: body.meta || {}
    };
}

export async function getDailyRangeDetails({ range, days = 3 } = {}, options = {}) {
    const params = new URLSearchParams({ range: String(range || ''), days: String(days) });
    const body = await apiRequest(`/daily-ranges/details?${params.toString()}`, options);
    return body.data || {
        range_value: range || '',
        days,
        sid_rows: [],
        destination_ranges: [],
        all_ranges_for_destinations: []
    };
}
